<template>
  <h1 class="text-xs-center my-4">
    PAGE NOT FOUND
  </h1>
</template>

<script>
export default {}
</script>
